__turbopack_context__.v({
  "className": "poppins_c1b0c304-module__RTLsjW__className",
  "variable": "poppins_c1b0c304-module__RTLsjW__variable",
});
